import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { jarvisPrimeTransactionConstants } from "./jarvisPrimeTransactionConstants";

const initialState = {
    transactionList: [],
    transactionCount: 0,
    transactionListApiCounter: 0,
    loading: {
        transactionList: 0,
    },
};

export const jarvisPrimeTransactionReducers = persistReducer(
    {
        storage,
        key: "transaction",
        blacklist: ["loading"],
    },
    (state = initialState, { type, payload }) => {
        switch (type) {
            case jarvisPrimeTransactionConstants.PRIME_RESET_TRANSACTION_DATA: {
                return initialState;
            }

            case jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_REQUEST: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        transactionList: 1,
                    },
                    transactionList: initialState.transactionList,
                    transactionCount: initialState.transactionCount,
                };
            }

            case jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_RESPONSE: {
                const { data, count } = payload;
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        transactionList: 0,
                    },
                    transactionList: data,
                    transactionCount: count,
                    transactionListApiCounter: state.transactionListApiCounter + 1,
                };
            }

            default:
                return state;
        }
    }
);
